<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：门店列表
      -->
  <div class="user">
    <!--添加门店-->
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" >添加分类</el-button></div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="一级分类名称" width=""></el-table-column>
          <el-table-column label="封面图片" width="200">
            <template slot-scope="scope">
              <img v-img-url="scope.row.save_name" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 1" class="green">上架</span>
              <span v-if="scope.row.state == 0" class="gray">下架</span>
            </template>
          </el-table-column> 
          <el-table-column prop="sort" label="序号" width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              <el-button @click="zifenleiAdd(scope.row)" type="text" size="small">添加子分类</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <!-- <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import codeApi from '@/api/code.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    zifenleiAdd(row){
      let self = this;
      let params = row.category_id;
      this.$router.push({
        path: '/card/category/zifenlei/index',
        // name: 'mallList',
        query: {
          parent_id: params
        }
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      // let Params = {};
      // Params.page = self.curPage;
      // Params.list_rows = self.pageSize;
    codeApi.cardType({parent_id:0}, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list
          // self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/card/category/add');
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.category_id;
      this.$router.push({
        path: '/card/category/edit',
        // name: 'mallList',
        query: {
          category_id: params
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          codeApi.cateDelete(
            {
              category_id: row.category_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/card/category/index.vue